export default {
  metadata: {
    version: '1.0.0',
    id: 'icon-1.0.0',
    name: 'JDSIcon'
  },
  hierarchy: {
    container: ['icon', 'lottie']
  },
  base: {
    container: {
      'background-color': '{icon_0}',
      'border-radius': '{icon_1}',
      size: '{icon_2}',
      'justify-content': '{icon_3}',
      'align-items': '{icon_4}'
    },
    icon: {
      size: '{icon_5}',
      color: '{icon_6}'
    },
    lottie: {
      hidden: true,
      size: '{icon_5}',
      repeat: true
    }
  },
  variant: {
    kind: {
      background: {},
      background_bold: {}
    },
    color: {
      primary_50: {
        icon: {
          color: '{icon_7}'
        }
      },
      primary_30: {
        icon: {
          color: '{icon_8}'
        }
      },
      primary_60: {
        icon: {
          color: '{icon_9}'
        }
      },
      primary_70: {
        icon: {
          color: '{icon_10}'
        }
      },
      primary_background: {
        icon: {
          color: '{icon_11}'
        }
      },
      secondary_50: {
        icon: {
          color: '{icon_12}'
        }
      },
      sparkle_50: {
        icon: {
          color: '{icon_13}'
        }
      },
      primary_grey_60: {
        icon: {
          color: '{icon_14}'
        }
      },
      primary_grey_80: {
        icon: {
          color: '{icon_15}'
        }
      },
      primary_grey_100: {
        icon: {
          color: '{icon_16}'
        }
      },
      feedback_success: {
        icon: {
          color: '{icon_17}',
          value: 'ic_success_colored'
        }
      },
      feedback_error: {
        icon: {
          color: '{icon_18}',
          value: 'ic_error_colored'
        }
      },
      feedback_warning: {
        icon: {
          color: '{icon_19}',
          value: 'ic_warning_colored'
        }
      },
      feedback_success_50: {
        icon: {
          color: '{icon_17}'
        }
      },
      feedback_error_50: {
        icon: {
          color: '{icon_18}'
        }
      },
      feedback_warning_50: {
        icon: {
          color: '{icon_19}'
        }
      },
      white: {
        icon: {
          color: '{icon_20}'
        }
      },
      none: {
        icon: {
          color: ''
        }
      }
    },
    size: {
      small: {
        container: {
          size: '{icon_21}'
        },
        icon: {
          size: '{icon_22}'
        },
        lottie: {
          size: '{icon_22}'
        }
      },
      large: {
        container: {
          size: '{icon_23}'
        },
        icon: {
          size: '{icon_24}'
        },
        lottie: {
          size: '{icon_24}'
        }
      },
      'xtra-large': {
        container: {
          size: '{icon_25}'
        },
        icon: {
          size: '{icon_26}'
        },
        lottie: {
          size: '{icon_26}'
        }
      },
      'xtra-xtra-large': {
        container: {
          size: '{icon_27}'
        },
        icon: {
          size: '{icon_28}'
        },
        lottie: {
          size: '{icon_28}'
        }
      }
    },
    _isLottieVisible: {
      true: {
        lottie: {
          hidden: false
        },
        icon: {
          hidden: true
        }
      }
    }
  },
  combination: [
    {
      background: {
        primary_50: {
          container: {
            'background-color': '{icon_31}'
          }
        },
        primary_30: {
          container: {
            'background-color': '{icon_32}'
          }
        },
        primary_60: {
          container: {
            'background-color': '{icon_33}'
          }
        },
        primary_70: {
          container: {
            'background-color': '{icon_34}'
          }
        },
        primary_background: {
          container: {
            'background-color': '{icon_35}'
          }
        },
        secondary_50: {
          container: {
            'background-color': '{icon_36}'
          }
        },
        sparkle_50: {
          container: {
            'background-color': '{icon_37}'
          }
        },
        primary_grey_60: {
          container: {
            'background-color': '{icon_38}'
          }
        },
        primary_grey_80: {
          container: {
            'background-color': '{icon_39}'
          }
        },
        primary_grey_100: {
          container: {
            'background-color': '{icon_40}'
          }
        },
        white: {
          container: {
            'background-color': '{icon_41}'
          }
        },
        feedback_success_50: {
          container: {
            'background-color': '{icon_42}'
          }
        },
        feedback_error_50: {
          container: {
            'background-color': '{icon_43}'
          }
        },
        feedback_warning_50: {
          container: {
            'background-color': '{icon_44}'
          }
        }
      },
      background_bold: {
        primary_50: {
          container: {
            'background-color': '{icon_45}'
          },
          icon: {
            color: '{icon_46}'
          }
        },
        primary_30: {
          container: {
            'background-color': '{icon_47}'
          },
          icon: {
            color: '{icon_48}'
          }
        },
        primary_60: {
          container: {
            'background-color': '{icon_49}'
          },
          icon: {
            color: '{icon_50}'
          }
        },
        primary_70: {
          container: {
            'background-color': '{icon_51}'
          },
          icon: {
            color: '{icon_52}'
          }
        },
        primary_background: {
          container: {
            'background-color': '{icon_53}'
          },
          icon: {
            color: '{icon_54}'
          }
        },
        secondary_50: {
          container: {
            'background-color': '{icon_55}'
          },
          icon: {
            color: '{icon_56}'
          }
        },
        sparkle_50: {
          container: {
            'background-color': '{icon_57}'
          },
          icon: {
            color: '{icon_58}'
          }
        },
        primary_grey_60: {
          container: {
            'background-color': '{icon_59}'
          },
          icon: {
            color: '{icon_60}'
          }
        },
        primary_grey_80: {
          container: {
            'background-color': '{icon_61}'
          },
          icon: {
            color: '{icon_62}'
          }
        },
        primary_grey_100: {
          container: {
            'background-color': '{icon_63}'
          },
          icon: {
            color: '{icon_64}'
          }
        },
        white: {
          container: {
            'background-color': '{icon_65}'
          },
          icon: {
            color: '{icon_66}'
          }
        },
        feedback_success_50: {
          container: {
            'background-color': '{icon_67}'
          },
          icon: {
            color: '{icon_68}'
          }
        },
        feedback_error_50: {
          container: {
            'background-color': '{icon_69}'
          },
          icon: {
            color: '{icon_70}'
          }
        },
        feedback_warning_50: {
          container: {
            'background-color': '{icon_71}'
          },
          icon: {
            color: '{icon_72}'
          }
        }
      }
    },
    {
      medium: {
        background: {
          container: {
            size: '{icon_73}'
          },
          icon: {
            size: '{icon_74}'
          },
          lottie: {
            size: '{icon_74}'
          }
        },
        background_bold: {
          container: {
            size: '{icon_112}'
          },
          icon: {
            size: '{icon_113}'
          },
          lottie: {
            size: '{icon_113}'
          }
        }
      },
      small: {
        background: {
          container: {
            size: '{icon_75}',
            'background-color': '{icon_76}'
          },
          icon: {
            size: '{icon_77}'
          },
          lottie: {
            size: '{icon_77}'
          }
        },
        background_bold: {
          container: {
            size: '{icon_114}'
          },
          icon: {
            size: '{icon_115}'
          },
          lottie: {
            size: '{icon_115}'
          }
        }
      },
      large: {
        background: {
          container: {
            size: '{icon_78}'
          },
          icon: {
            size: '{icon_79}'
          },
          lottie: {
            size: '{icon_79}'
          }
        },
        background_bold: {
          container: {
            size: '{icon_116}'
          },
          icon: {
            size: '{icon_117}'
          },
          lottie: {
            size: '{icon_117}'
          }
        }
      },
      'xtra-large': {
        background: {
          container: {
            size: '{icon_80}'
          },
          icon: {
            size: '{icon_81}'
          },
          lottie: {
            size: '{icon_81}'
          }
        },
        background_bold: {
          container: {
            size: '{icon_118}'
          },
          icon: {
            size: '{icon_119}'
          },
          lottie: {
            size: '{icon_119}'
          }
        }
      },
      'xtra-xtra-large': {
        background: {
          container: {
            size: '{icon_82}'
          },
          icon: {
            size: '{icon_83}'
          },
          lottie: {
            size: '{icon_83}'
          }
        },
        background_bold: {
          container: {
            size: '{icon_120}'
          },
          icon: {
            size: '{icon_121}'
          },
          lottie: {
            size: '{icon_121}'
          }
        }
      }
    },
    {
      small: {
        background_bold: {
          primary_50: {
            container: {
              'background-color': '{icon_84}'
            },
            icon: {
              color: '{icon_85}'
            }
          },
          primary_30: {
            container: {
              'background-color': '{icon_86}'
            },
            icon: {
              color: '{icon_87}'
            }
          },
          primary_60: {
            container: {
              'background-color': '{icon_88}'
            },
            icon: {
              color: '{icon_89}'
            }
          },
          primary_70: {
            container: {
              'background-color': '{icon_90}'
            },
            icon: {
              color: '{icon_91}'
            }
          },
          primary_background: {
            container: {
              'background-color': '{icon_92}'
            },
            icon: {
              color: '{icon_93}'
            }
          },
          secondary_50: {
            container: {
              'background-color': '{icon_94}'
            },
            icon: {
              color: '{icon_95}'
            }
          },
          sparkle_50: {
            container: {
              'background-color': '{icon_96}'
            },
            icon: {
              color: '{icon_97}'
            }
          },
          primary_grey_60: {
            container: {
              'background-color': '{icon_98}'
            },
            icon: {
              color: '{icon_99}'
            }
          },
          primary_grey_80: {
            container: {
              'background-color': '{icon_100}'
            },
            icon: {
              color: '{icon_101}'
            }
          },
          primary_grey_100: {
            container: {
              'background-color': '{icon_102}'
            },
            icon: {
              color: '{icon_103}'
            }
          },
          white: {
            container: {
              'background-color': '{icon_104}'
            },
            icon: {
              color: '{icon_105}'
            }
          },
          feedback_success_50: {
            container: {
              'background-color': '{icon_106}'
            },
            icon: {
              color: '{icon_107}'
            }
          },
          feedback_error_50: {
            container: {
              'background-color': '{icon_108}'
            },
            icon: {
              color: '{icon_109}'
            }
          },
          feedback_warning_50: {
            container: {
              'background-color': '{icon_110}'
            },
            icon: {
              color: '{icon_111}'
            }
          }
        }
      },
      medium: {
        background: {
          feedback_success: {
            container: {
              size: '{icon_122}'
            },
            icon: {
              size: '{icon_125}'
            },
            lottie: {
              size: '{icon_125}'
            }
          },
          feedback_error: {
            container: {
              size: '{icon_123}'
            },
            icon: {
              size: '{icon_126}'
            },
            lottie: {
              size: '{icon_126}'
            }
          },
          feedback_warning: {
            container: {
              size: '{icon_124}'
            },
            icon: {
              size: '{icon_127}'
            },
            lottie: {
              size: '{icon_127}'
            }
          }
        },
        background_bold: {
          feedback_success: {
            container: {
              size: '{icon_128}'
            },
            icon: {
              size: '{icon_131}'
            },
            lottie: {
              size: '{icon_131}'
            }
          },
          feedback_error: {
            container: {
              size: '{icon_129}'
            },
            icon: {
              size: '{icon_132}'
            },
            lottie: {
              size: '{icon_132}'
            }
          },
          feedback_warning: {
            container: {
              size: '{icon_130}'
            },
            icon: {
              size: '{icon_133}'
            },
            lottie: {
              size: '{icon_133}'
            }
          }
        }
      },
      large: {
        background: {
          feedback_success: {
            container: {
              size: '{icon_135}'
            },
            icon: {
              size: '{icon_137}'
            },
            lottie: {
              size: '{icon_137}'
            }
          },
          feedback_error: {
            container: {
              size: '{icon_136}'
            },
            icon: {
              size: '{icon_138}'
            },
            lottie: {
              size: '{icon_138}'
            }
          },
          feedback_warning: {
            container: {
              size: '{icon_136}'
            },
            icon: {
              size: '{icon_139}'
            },
            lottie: {
              size: '{icon_139}'
            }
          }
        },
        background_bold: {
          feedback_success: {
            container: {
              size: '{icon_140}'
            },
            icon: {
              size: '{icon_143}'
            },
            lottie: {
              size: '{icon_143}'
            }
          },
          feedback_error: {
            container: {
              size: '{icon_141}'
            },
            icon: {
              size: '{icon_144}'
            },
            lottie: {
              size: '{icon_144}'
            }
          },
          feedback_warning: {
            container: {
              size: '{icon_142}'
            },
            icon: {
              size: '{icon_145}'
            },
            lottie: {
              size: '{icon_145}'
            }
          }
        }
      },
      'xtra-large': {
        background: {
          feedback_success: {
            container: {
              size: '{icon_146}'
            },
            icon: {
              size: '{icon_149}'
            },
            lottie: {
              size: '{icon_149}'
            }
          },
          feedback_error: {
            container: {
              size: '{icon_147}'
            },
            icon: {
              size: '{icon_150}'
            },
            lottie: {
              size: '{icon_150}'
            }
          },
          feedback_warning: {
            container: {
              size: '{icon_148}'
            },
            icon: {
              size: '{icon_151}'
            },
            lottie: {
              size: '{icon_151}'
            }
          }
        },
        background_bold: {
          feedback_success: {
            container: {
              size: '{icon_152}'
            },
            icon: {
              size: '{icon_155}'
            },
            lottie: {
              size: '{icon_155}'
            }
          },
          feedback_error: {
            container: {
              size: '{icon_153}'
            },
            icon: {
              size: '{icon_156}'
            },
            lottie: {
              size: '{icon_156}'
            }
          },
          feedback_warning: {
            container: {
              size: '{icon_154}'
            },
            icon: {
              size: '{icon_157}'
            },
            lottie: {
              size: '{icon_157}'
            }
          }
        }
      },
      'xtra-xtra-large': {
        background: {
          feedback_success: {
            container: {
              size: '{icon_158}'
            },
            icon: {
              size: '{icon_161}'
            },
            lottie: {
              size: '{icon_161}'
            }
          },
          feedback_error: {
            container: {
              size: '{icon_159}'
            },
            icon: {
              size: '{icon_162}'
            },
            lottie: {
              size: '{icon_162}'
            }
          },
          feedback_warning: {
            container: {
              size: '{icon_160}'
            },
            icon: {
              size: '{icon_163}'
            },
            lottie: {
              size: '{icon_163}'
            }
          }
        },
        background_bold: {
          feedback_success: {
            container: {
              size: '{icon_164}'
            },
            icon: {
              size: '{icon_167}'
            },
            lottie: {
              size: '{icon_167}'
            }
          },
          feedback_error: {
            container: {
              size: '{icon_165}'
            },
            icon: {
              size: '{icon_168}'
            },
            lottie: {
              size: '{icon_168}'
            }
          },
          feedback_warning: {
            container: {
              size: '{icon_166}'
            },
            icon: {
              size: '{icon_169}'
            },
            lottie: {
              size: '{icon_169}'
            }
          }
        }
      }
    }
  ],
  combination_config: [
    ['kind', 'color'],
    ['size', 'kind'],
    ['size', 'kind', 'color']
  ],
  api: {
    config: {
      size: {
        values: ['medium', 'small', 'large', 'xtra-large', 'xtra-xtra-large'],
        doc_description:
          'It can be used to control size of icon. Please note that the actual size of the icon inside will vary based on the `kind` selected.'
      },
      color: {
        values: [
          'primary_50',
          'primary_30',
          'primary_60',
          'primary_70',
          'primary_background',
          'secondary_50',
          'sparkle_50',
          'primary_grey_60',
          'primary_grey_80',
          'primary_grey_100',
          'feedback_success',
          'feedback_error',
          'feedback_warning',
          'feedback_success_50',
          'feedback_error_50',
          'feedback_warning_50',
          'white',
          'none'
        ]
      },
      kind: {
        values: ['default', 'background', 'background_bold'],
        doc_description:
          "It can be used to switch between 3 variants of Icon. 'background-bold' sets color prop as bg, Icon color is inverse of that."
      },
      _isLottieVisible: {
        values: [false, true]
      }
    },
    data: {
      icon: {
        value: {
          type: 'icon',
          name: 'ic',
          function: true,
          doc_description:
            "It can take the icon user want to pass or the name of icon. e.g. `ic={<IcFavorite/>}` or `ic='IcFavorite'`. User can also pass a any custom icon he may have stored locally."
        },
        semantics: {
          type: 'string',
          name: 'semantics'
        }
      },
      lottie: {
        value: {
          type: 'icon',
          name: 'ic',
          function: true,
          doc_description:
            "It can take the icon user want to pass or the name of icon. e.g. `ic={<IcFavorite/>}` or `ic='IcFavorite'`. User can also pass a any custom icon he may have stored locally."
        },
        attributes: {
          type: 'object',
          name: 'lottieAttributes',
          platform: 'android',
          object: {
            repeatCount: 'number',
            maxRetryCount: 'number',
            speed: 'float',
            reverseOnRepeat: 'boolean',
            clipSpec: 'LottieClipSpec'
          }
        }
      }
    },
    events: {
      container: {
        onClick: 'onClick'
      }
    },
    a11y: {
      icon: {
        properties: {
          role: {
            value: 'img'
          },
          'aria-label': {
            name: 'ariaLabel',
            function: true
          }
        }
      }
    }
  }
};
